import { z } from 'zod';
const denyVolunteeringHoursParamsSchema = z.object({
    participationId: z.string().uuid(),
    status: z.enum(['deniedInaccurate', 'deniedNoShow']),
});
export const denyVolunteeringHoursFunctionDef = {
    name: 'denyVolunteeringHours',
    requestSchema: denyVolunteeringHoursParamsSchema,
    responseSchema: z.void(),
};
